module.exports = __webpack_public_path__ + "static/media/art-moderne.b9c44b5a.jpg";